import { render, staticRenderFns } from "./BecomeATeacherList.vue?vue&type=template&id=d03b1f70&"
import script from "./BecomeATeacherList.vue?vue&type=script&lang=js&"
export * from "./BecomeATeacherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports